import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { Keepalive, NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgAddToCalendarModule } from '@trademe/ng-add-to-calendar';
import { CalendarModule } from 'angular-calendar';
import { MomentModule } from 'angular2-moment';
import { PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { AccordionAnchorDirective, AccordionDirective, AccordionLinkDirective, AuthLayoutComponent } from './core';
import { AuthGuard } from './services/shared/auth.guard';
import { AuthService } from './services/shared/auth.service';
import { CustomPreloading } from './services/shared/custom-preloading';
import { GlobalErrorHandler } from './services/shared/global-error-handler.service';
import { LogPublishersService } from './services/shared/log-publishers.service';
import { LogService } from './services/shared/log.service';
import { NGaugeService } from './services/shared/ngauge.service';
import { PubSubService } from './services/shared/pub-sub.service';
import { UserService } from './services/user.service';
import { SharedModule } from './shared/shared.module';
import { VersionCheckService } from './shared/version-check.service';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
  minScrollbarLength: 20
};

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective
  ],
  imports: [
    NgAddToCalendarModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, { preloadingStrategy: CustomPreloading, enableTracing: false, useHash: true }),
    HttpClientModule,
    NgIdleKeepaliveModule,
    MomentModule,
    CalendarModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 7000,
      extendedTimeOut: 5000,
      progressAnimation: 'decreasing',
      positionClass: 'toast-bottom-right',
      progressBar: true
    }),
    SharedModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    Keepalive,
    AuthService,
    AuthGuard,
    LogService,
    LogPublishersService,
    NGaugeService,
    UserService,
    ToastrService,
    PubSubService,
    CustomPreloading,
    VersionCheckService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts